import React, { FC } from "react";

import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import { faMagnifyingGlassMinus } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlassMinus";
import { faMagnifyingGlassPlus } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlassPlus";
import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "antd/es/tooltip";
import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

const messages = defineMessages({
  resetZoom: {
    id: "files.filePreviewPage.info.buttons.resetZoom",
    defaultMessage: "Reset zoom",
    description: "Reset zoom button on the File Preview page",
  },
  zoomIn: {
    id: "files.filePreviewPage.info.buttons.zoomIn",
    defaultMessage: "Zoom in",
    description: "Zoom in button on the File Preview page",
  },
  zoomOut: {
    id: "files.filePreviewPage.info.buttons.zoomOut",
    defaultMessage: "Zoom out",
    description: "Zoom out button on the File Preview page",
  },
});

const ZOOM_MULTIPLIER = 1.5;
const MIN_ZOOM = 0.1;
const MAX_ZOOM = 10;

export interface ActionButtonsProps {
  canDownload?: boolean;
  isImageFile?: boolean;
  onDownload: () => void;
  onZoomChange: (zoom: ((currentZoom: number) => number) | number) => void;
  zoom: number;
}

const ActionButtons: FC<ActionButtonsProps> = ({
  canDownload,
  isImageFile,
  onDownload,
  onZoomChange,
  zoom,
}) => {
  const intl = useIntl();

  return (
    <div>
      {isImageFile && (
        <>
          {zoom !== 1 && (
            <Tooltip title={intl.formatMessage(messages.resetZoom)}>
              <Button
                icon={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onClick={() => onZoomChange(1)}
                size="large"
                type="text"
              />
            </Tooltip>
          )}
          <Tooltip title={intl.formatMessage(messages.zoomOut)}>
            <Button
              disabled={zoom < MIN_ZOOM}
              icon={<FontAwesomeIcon icon={faMagnifyingGlassMinus} />}
              onClick={() => onZoomChange((zoom) => zoom / ZOOM_MULTIPLIER)}
              size="large"
              type="text"
            />
          </Tooltip>
          <Tooltip title={intl.formatMessage(messages.zoomIn)}>
            <Button
              disabled={zoom > MAX_ZOOM}
              icon={<FontAwesomeIcon icon={faMagnifyingGlassPlus} />}
              onClick={() => onZoomChange((zoom) => zoom * ZOOM_MULTIPLIER)}
              size="large"
              type="text"
            />
          </Tooltip>
        </>
      )}
      <Button
        disabled={!canDownload}
        icon={<FontAwesomeIcon icon={faDownload} />}
        onClick={onDownload}
        size="large"
        type="text"
      />
    </div>
  );
};

export default ActionButtons;
